/* eslint-disable */
import Vue from 'vue'
import VueRouter from 'vue-router'
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(VueRouter)

const routes = [
    // 主营业务/算力服务
    {
        path: '/mainbusines',
        name: 'mainbusines',
        component: () =>
            import('@/views/comservices.vue')
    },
    {
        path: '/',
        name: 'Home',
        component: () =>
            import ('@/views/Home.vue')
    },
    // 资讯
    {
        path: '/news',
        name: 'news',
        component: () =>
            import ('@/views/news.vue')
    },
    // 中科逆熵
    {
        path: '/extrotec',
        name: 'extrotec',
        component: () =>
            import ('@/views/extrotec.vue')
    },
     // 智能中心
     {
        path: '/aicenter',
        name: 'aicenter',
        component: () =>
            import ('@/views/aicenter.vue')
    },
    // 联系我们
    {
        path: '/new-aboutus',
        name: 'new-aboutus',
        component: () =>
            import ('@/views/new-aboutus.vue')
    },
    // 加入我们
    {
        path: '/joinus',
        name: 'joinus',
        component: () =>
            import ('@/views/joinus.vue')
    },
    // 新闻详情
    {
        path: '/newsDetails',
        name: 'newsDetails',
        component: () =>
            import ('@/views/newsDetails.vue')
    },

    // 激活paas
    {
        path: '/activation',
        name: 'activation',
        component: () =>
            import ('@/views/activation.vue')
    },
    // 外部登录中转
    {
        path: '/loginCheck',
        name: 'loginCheck',
        component: () =>
            import ('@/views/login/loginCheck.vue')
    },
  
    // 行业案例
    {
        path: '/industryCases',
        name: 'industryCases',
        component: () =>
            import ('@/views/IndustryCases.vue')
    },
    // ai教育案例
    {
        path: '/aiCase',
        name: 'aiCase',
        component: () =>
            import ('@/views/aiCase.vue')
    },
    // ai教育案例
    {
        path: '/aiCo',
        name: 'aiCo',
        component: () =>
            import ('@/views/bussiness/aiCo.vue')
    },
    {
        path: '/extraMaas',
        name: 'extraMaas',
        component: () =>
            import ('@/views/bussiness/extraMaas.vue')
    },
    {
        path: '/extraPaas',
        name: 'extraPaas',
        component: () =>
            import ('@/views/bussiness/extraPaas.vue')
    },
    {
        path: '/extraIaas',
        name: 'extraIaas',
        component: () =>
            import ('@/views/bussiness/extraIaas.vue')
    },
    {
        path: '/extraStor',
        name: 'extraStor',
        component: () =>
            import ('@/views/bussiness/extraStor.vue')
    },
    {
        path: '/aiFactory',
        name: 'aiFactory',
        component: () =>
            import ('@/views/bussiness/aiFactory.vue')
    },
]

const router = new VueRouter({
    mode: 'history',
    routes
})

export default router
